// Shared administration constants.
export const TIMEZONES = [
  ["America/New_York", "Eastern (Miami / New York)"],
  ["America/Chicago", "Central (Chicago)"],
  ["America/Denver", "Mountain (Denver)"],
  ["America/Phoenix", "Arizona (Phoenix)"],
  ["America/Los_Angeles", "Pacific (Los Angeles)"],
  ["America/Puerto_Rico", "Atlantic (Puerto Rico)"],
];

export const ROLE_LABEL = {
  global_administrator: "Global Administrator",
  administrator: "Administrator",
  salesperson: "Salesperson",
};

export const PRESENCE_META = {
  active: { color: "#22C55E", label: "Active" },
  idle: { color: "#F59E0B", label: "Idle" },
  offline: { color: "#9CA3AF", label: "Offline" },
};

export function PresenceDot({ presence, testId }) {
  const meta = PRESENCE_META[presence] || PRESENCE_META.offline;
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={testId} title={meta.label}>
      <span className="h-2 w-2 rounded-full" style={{ backgroundColor: meta.color }} />
      <span className="text-[10px] font-semibold uppercase tracking-wide text-[#6D6D70]">{meta.label}</span>
    </span>
  );
}
